// extracted by mini-css-extract-plugin
module.exports = {"makeLabel":"MakeLabel_makeLabel__iMD_d","logo":"MakeLabel_logo__9M_HY","name":"MakeLabel_name__IH9SP"};